import React from "react";
import { useContext, useState } from "react";
import styles from "./Mpesa.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./Details";
import { BackToMethods } from "../../common/BackToMethods";
import { WalletPayProps } from "../Wallet";
import axios from "axios";
import { sendMessage } from "../../../context/utils";
import { StatusContext } from "../../../context/Status";
import { StatusMessage } from "../../StatusMessage";
import { CodeSent } from "../../common/CodeSent";
import { ErrorAlertContext } from "../../../context/ErrorAlert";

export const MpesaMethod = () => {
  const { email, currency, amount, payData, merchantKey } =
    useContext(RoutingContext);
  const { setPageTransactionStatus } = useContext(StatusContext);
  const { onShowAlert } = useContext(ErrorAlertContext);

  const [mobileTnxRef, setMobileTnxRef] = useState("");
  const [ref, setRef] = useState("");
  const [mobileTnxId, setMobileTnxId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [tabDisplayed, setTabDisplayed] = useState("login");
  const [emailError, setEmailError] = useState("");
  let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  const baseRoute = currency === "KES"  ? `pay/${currency}/mobilemoney/v2` : `pay/${currency}/cardpayment`;

  const onContinue = async (data?: WalletPayProps) => {
    let payload = {
      ...payData.kit,
      email: payData?.kit?.email,
      phone_number: data?.phone ? data.phone.replaceAll(/\s+/g, "") : "",
      option: "mpesa",
      fullname: data?.fullname,
      paylinkToken: payData.kit.paylinkToken,
      paymentType: payData.kit?.paymentType || 'html-checkout',
    };

    if (!data?.email.match(mailformat) || !data?.email) {
      setEmailError("Please enter a valid email address");
    } else {
      try {
        setIsLoading(true);
        const response = await axios({
          method: "post",
          url:  `${process.env.REACT_APP_API_URL}${baseRoute}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
            ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
              "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
            })
          },
          data: payload,
        });
        const responseData = response.data;
        setRef(responseData?.tx_ref);
        

        if (responseData.status === "error") {
          setTabDisplayed("error");
          setPageTransactionStatus("error");
          setTimeout(() => {
            sendMessage({ status: "ERROR" });
          }, 5000);
          return;
        }
        setMobileTnxRef(responseData.data.tx_ref);
        setMobileTnxId(responseData.data.id);
        setTabDisplayed("codesent");
        setPageTransactionStatus("codesent");
        setIsLoading(false);
      } catch (error) {
        onShowAlert(error, "Please try again");
        setIsLoading(false);
        setTabDisplayed("error");
        setPageTransactionStatus("error");
      }
    }
  };

  const onSubmit = async () => {
    if (ref != "") {
      const payload = {
        txnRef: ref,
      };

      try {
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}nucleus/wordpressstatus/tnxrefStatus`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-auth-token": merchantKey,
          },
          data: payload,
        });
        const responseData = response.data;

        if (responseData["status"] === "successful") {
          setTabDisplayed("success");
          setPageTransactionStatus("success");
          const dataResp = { status: "successful" };
          setTimeout(() => {
            sendMessage(dataResp);
          }, 5000);
        } else if (
          responseData["status"].toLowerCase() === "pending" &&
          ["Charge initiated", "pending"].includes(responseData["message"])
        ) {
        //   setIsPending(true);
          return;
        } else {
          setTabDisplayed("error");
          setPageTransactionStatus("error");
          const dataResp = { status: "ERROR" };
          setTimeout(() => {
            sendMessage(dataResp);
          }, 5000);
        }
      } catch (error) {
        setTabDisplayed("error");
        setTimeout(() => {
          sendMessage({ status: "ERROR" });
        }, 5000);
      }
    }
  };

  

  if (tabDisplayed === "codesent") {
    return <CodeSent onPaid={onSubmit} isLoading={isLoading} />;
  }

  if (tabDisplayed === "error" || tabDisplayed === "success") {
    return <StatusMessage type={tabDisplayed} />;
  }

  return (
    <MobileWrapper>
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={currency} />
          <div className={styles.body}>
            <Details
              onPay={onContinue}
              defaultName={payData.kit.fullname}
              defaultPhone={payData.kit?.phone_number}
              defaultEmail={payData.kit?.email}
              isLoading={isLoading}
              emailError={emailError}
              setEmailError={setEmailError}
            />
          </div>
          {tabDisplayed !== "codesent" && <BackToMethods />}
        </div>

        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
